import { LoadingSpinner } from "components";
import { useBucketContext } from "context/bucket";
import { FC, useEffect } from "react";

type FetchContentProps = { setElements: (elements: string[]) => void };

export const FetchContent: FC<FetchContentProps> = ({ setElements }) => {
  const { fetchBucket } = useBucketContext();

  const executeFetch = async () => {
    const result = await fetchBucket();
    if (result?.Contents) {
      const keys = result?.Contents?.filter((o) => Boolean(o?.Key)).map(
        (o) => o.Key
      ) as string[];
      console.log(keys);
      setElements(keys);
      return;
    }
    setElements([]);
  };

  useEffect(() => {
    executeFetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <LoadingSpinner />;
};
